export default __webpack_public_path__ + "static/media/samsung-icon.936b4ed6.png";